//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0]],[[[],"GetSignalData",{R_:{signalData:''}},0,1],[[],"GetSignalDataV2",{R_:{signalData:''}},0,1],[[],"GetSignal",{R_:{signalData:"Mechatronics.GenericSignal"}},0,0],[["signalData"],"SetSignalData",{},1,1],[["signalData"],"SetSignalDataV2",{},1,1],[["signalData"],"SetSignal",{},1,0]],[]];
SPLM.Mechatronics.SignalBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SignalBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SignalBuilder.Signal = class{
    constructor(tgPhysicsObject,nPhysicsPropTag,eIOType,eDataType,boolValueExp,intValueExp,doubleValueExp){
        this.tgPhysicsObject=tgPhysicsObject;this.nPhysicsPropTag=nPhysicsPropTag;this.eIOType=eIOType;this.eDataType=eDataType;this.boolValueExp=boolValueExp;this.intValueExp=intValueExp;this.doubleValueExp=doubleValueExp;}
    get Tgphysicsobject(){return this.tgPhysicsObject}
    set Tgphysicsobject(val){this.tgPhysicsObject = val}
    get Nphysicsproptag(){return this.nPhysicsPropTag}
    set Nphysicsproptag(val){this.nPhysicsPropTag = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Boolvalueexp(){return this.boolValueExp}
    set Boolvalueexp(val){this.boolValueExp = val}
    get Intvalueexp(){return this.intValueExp}
    set Intvalueexp(val){this.intValueExp = val}
    get Doublevalueexp(){return this.doubleValueExp}
    set Doublevalueexp(val){this.doubleValueExp = val}
};

SPLM.Mechatronics.SignalBuilder.SignalV2 = class{
    constructor(tgPhysicsObject,nPhysicsPropTag,eIOType,eDataType,boolValueExp,intValueExp,doubleValueExp,stringValueExp){
        this.tgPhysicsObject=tgPhysicsObject;this.nPhysicsPropTag=nPhysicsPropTag;this.eIOType=eIOType;this.eDataType=eDataType;this.boolValueExp=boolValueExp;this.intValueExp=intValueExp;this.doubleValueExp=doubleValueExp;this.stringValueExp=stringValueExp;}
    get Tgphysicsobject(){return this.tgPhysicsObject}
    set Tgphysicsobject(val){this.tgPhysicsObject = val}
    get Nphysicsproptag(){return this.nPhysicsPropTag}
    set Nphysicsproptag(val){this.nPhysicsPropTag = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Boolvalueexp(){return this.boolValueExp}
    set Boolvalueexp(val){this.boolValueExp = val}
    get Intvalueexp(){return this.intValueExp}
    set Intvalueexp(val){this.intValueExp = val}
    get Doublevalueexp(){return this.doubleValueExp}
    set Doublevalueexp(val){this.doubleValueExp = val}
    get Stringvalueexp(){return this.stringValueExp}
    set Stringvalueexp(val){this.stringValueExp = val}
};

SPLM.Mechatronics.SignalBuilder.IOType = Object.freeze({
    "Input" : "Input", "Output" : "Output"});

SPLM.Mechatronics.SignalBuilder.ExternalSignalIOType = Object.freeze({
    "Input" : "Input", "Output" : "Output", "Inout" : "Inout"});

SPLM.Mechatronics.SignalBuilder.DataType = Object.freeze({
    "Bool" : "Bool", "Int" : "Int", "Double" : "Double", "String" : "String"});

SPLM.Mechatronics.SignalBuilder.ExternalSignalDataType = Object.freeze({
    "Bool" : "Bool", "Byte" : "Byte", "Word" : "Word", "Int" : "Int", "Dword" : "Dword", "Dint" : "Dint", "Real" : "Real", "Lreal" : "Lreal", "String" : "String"});

export default SPLM;